import React, {Component} from "react";
import {FaIcon} from "../../FaIcon";
import {adgroupLevelLabel} from "../../../utils/channelLevelLabels";

// Los textos van a texto React, que ya escapa: sin esto i18next escaparía de nuevo lo interpolado.
const RAW = {escapeValue: false};
// Alto máximo del cartel `-rich` con este texto (4 renglones a 340 px, medido: 100 px) con margen.
const TOOLTIP_HEIGHT = 120;

/**
 * El nombre de la fila «Sin identificar» de una campaña abierta: el tráfico de GA4 de esa campaña
 * que no coincide con ninguno de sus grupos de anuncios (contrato de la tanda «Cruce paid media ↔
 * GA4», § 5). Es la fila que hace que los grupos sumen lo mismo que la campaña.
 *
 * El nivel se nombra como lo llama la plataforma de la cuenta (`channel`). El ⓘ explica de dónde
 * sale la fila nombrando el parámetro que se cruza, así que se dibuja sólo cuando la regla cruza por
 * NOMBRE un parámetro conocido: por ID o con Google (automático, sin UTM) el texto no aplica, y sin
 * `rule` (backend sin el campo) no hay parámetro que nombrar.
 *
 * En el portal del cliente (`readOnly`) tampoco: ahí la primera columna recorta lo que se sale
 * (`overflow: hidden`, `_portal_dashboard_table.scss`) y el cartel quedaba cortado por la celda. La
 * pista ya explica la fila (C-tablero-frontend-03).
 *
 * Recibe `t` del Tablero en vez de envolverse en `withTranslation`, como las otras celdas de nombre
 * de las sub-filas.
 */
export class UnidentifiedNameCell extends Component {
    state = {tooltipUp: false};

    // El cartel abre hacia abajo; con la fila al pie del Tablero lo recortaba `.table-box.-dashboard`
    // (`overflow: auto`) y se leían 2 de sus 4 renglones (QA-VIS-tabfe-01). Se mide al abrirlo, como
    // las celdas de métrica, pero contra el borde de la caja de la tabla, que es lo que recorta.
    handleTooltipEnter = (event) => {
        const rect = event.currentTarget.getBoundingClientRect();
        const box = event.currentTarget.closest('.table-box');
        const limit = box ? Math.min(window.innerHeight, box.getBoundingClientRect().bottom) : window.innerHeight;
        const tooltipUp = rect.top + TOOLTIP_HEIGHT > limit;
        if (tooltipUp !== this.state.tooltipUp) {
            this.setState({tooltipUp});
        }
    };

    tooltipText() {
        const {t, channel, rule, readOnly} = this.props;
        if (readOnly || !rule || !rule.adgroup_param || rule.match_by !== 'name') {
            return null;
        }
        return t('dashboard_row.unidentified_tooltip', {
            param: rule.adgroup_param,
            levelPlural: adgroupLevelLabel(t, channel, {count: 2}),
            interpolation: RAW,
        });
    }

    renderInfo() {
        const tooltipText = this.tooltipText();
        if (!tooltipText) {
            return <>&nbsp;</>;
        }
        return (
            <div className="info-icon-container -stronger unidentified-info" tabIndex={0} aria-label={tooltipText}
                 onMouseEnter={this.handleTooltipEnter} onFocus={this.handleTooltipEnter}>
                <FaIcon iconName="info-circle"/>
                <div className={`warning-tooltip -rich${this.state.tooltipUp ? ' -up' : ''}`}>
                    <div className="warning-tooltip-body">
                        <p className="warning-tooltip-text">{tooltipText}</p>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const {t, channel} = this.props;
        const hint = t('dashboard_row.unidentified_hint', {
            level: adgroupLevelLabel(t, channel),
            interpolation: RAW,
        });
        return (
            <td>
                <div className="bu-cell ad_account_row">
                    <div className="bu-name-with-tooltip">
                        <div className="adgroup-name unidentified-name">
                            {/* La flecha fuera de la itálica: si no, Chrome le sintetiza la oblicua al
                                emoji y no es la misma de los grupos hermanos (QA-VIS-tabfe-02). */}
                            <span>➡️ <span className="unidentified-label">{t('dashboard_row.unidentified_name')}</span></span>
                            <span className="unidentified-hint"> · {hint}</span>
                        </div>
                    </div>
                    <div className="some-icons">
                        {this.renderInfo()}
                    </div>
                </div>
            </td>
        );
    }
}
